<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="3.78" height="7.56" viewBox="0 0 3.78 7.56" fill="currentColor">
    <polygon points="0 0 3.78 3.78 0 7.56 0 0" />
  </svg>
</template>
